var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.signalRSocket)?_c('OnlineRoomsList',{attrs:{"signalRSocket":_vm.signalRSocket}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }